// Tiny WebAudio cues for practice drills — no assets, no network, no latency.
// Pairs with the visual juice in ./juice.js: confetti for the eye, a chime for
// the ear. Muting is remembered per device.

let ctx = null
const MUTE_KEY = 'drillSoundMuted'

export const isMuted = () => { try { return localStorage.getItem(MUTE_KEY) === '1' } catch { return false } }
export const setMuted = (m) => { try { localStorage.setItem(MUTE_KEY, m ? '1' : '0') } catch { /* private mode */ } }

// Lazily create (and resume) the audio context. Cues always fire from a click,
// so the browser's user-gesture requirement is already satisfied.
const audio = () => {
  if (isMuted()) return null
  const AC = window.AudioContext || window.webkitAudioContext
  if (!AC) return null
  try {
    if (!ctx) ctx = new AC()
    if (ctx.state === 'suspended') ctx.resume()
    return ctx
  } catch { return null }
}

// One soft note. Exponential ramps keep it round rather than clicky.
function blip(ac, freq, at, dur, gain = 0.09, type = 'sine') {
  const osc = ac.createOscillator()
  const amp = ac.createGain()
  osc.type = type
  osc.frequency.value = freq
  osc.connect(amp)
  amp.connect(ac.destination)
  const t = ac.currentTime + at
  amp.gain.setValueAtTime(0.0001, t)
  amp.gain.exponentialRampToValueAtTime(gain, t + 0.012)
  amp.gain.exponentialRampToValueAtTime(0.0001, t + dur)
  osc.start(t)
  osc.stop(t + dur + 0.03)
}

// Rising two-note "yes".
export function cueCorrect() {
  const ac = audio(); if (!ac) return
  blip(ac, 660, 0, 0.12)
  blip(ac, 990, 0.085, 0.16)
}

// Low, soft "not quite" — a nudge, never a buzzer.
export function cueWrong() {
  const ac = audio(); if (!ac) return
  blip(ac, 196, 0, 0.16, 0.07, 'triangle')
  blip(ac, 155, 0.095, 0.2, 0.06, 'triangle')
}

// Little arpeggio when a set is finished.
export function cueComplete() {
  const ac = audio(); if (!ac) return
  ;[523, 659, 784, 1047].forEach((f, i) => blip(ac, f, i * 0.095, 0.24, 0.08))
}

// A single bright tick — a hint being opened, a streak milestone.
export function cueTick() {
  const ac = audio(); if (!ac) return
  blip(ac, 880, 0, 0.08, 0.05)
}
